import {
  APPOINTMENTS,
  APPOINTMENTSPRICING,
  APPOINTMENT_TYPES,
  APPOINTMENT_CATEGORIES,
  APPOINTMENT_TRAINERS,
  APPOINTMENT_DOT_DATES,
  RESET_PT_SLOT_DATES,
  REMOVE_PT_SLOT_DATE,
  CLEARSTATUS,
  FETCH_APPOINTMENTS,
  APPOINTMENTSTATE,
  DONE_FETCHING_APPOINTMENTS,
  BOOKPT
} from 'Constants'

const INITIAL_STATE = {
  appointments: null,
  appointmentsPricing: {},
  appointmentState: null,
  appointmentTypes: [],
  appointmentCategories: [],
  trainers: [],
  isFetchingAppointments: false,
  bookPtDetail: null,
  ptSlotDates: []
}

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case APPOINTMENTS: {
      const incomingDates = action.payload?.data?.slot_dates ?? []
      const merged = incomingDates.length
        ? [...new Set([...state.ptSlotDates, ...incomingDates])]
        : state.ptSlotDates
      return {
        ...state,
        appointments: action.payload,
        ptSlotDates: merged
      }
    }
    case APPOINTMENTSTATE:
      return { ...state, appointmentState: action.payload }

    case FETCH_APPOINTMENTS:
      return { ...state, isFetchingAppointments: true }

    case DONE_FETCHING_APPOINTMENTS:
      return { ...state, isFetchingAppointments: false }

    case APPOINTMENTSPRICING:
      return { ...state, appointmentsPricing: action.payload }

    case APPOINTMENT_TYPES:
      return { ...state, appointmentTypes: action.payload }

    case APPOINTMENT_CATEGORIES:
      return { ...state, appointmentCategories: action.payload }

    case APPOINTMENT_TRAINERS:
      return { ...state, trainers: action.payload }
    case APPOINTMENT_DOT_DATES:
      return { ...state, ptSlotDates: action.payload }

    case RESET_PT_SLOT_DATES:
      return { ...state, ptSlotDates: [] }

    case REMOVE_PT_SLOT_DATE:
      return {
        ...state,
        ptSlotDates: state.ptSlotDates.filter(d => d !== action.payload)
      }

    case BOOKPT:
      return { ...state, bookPtDetail: action.payload }

    case CLEARSTATUS:
      return {
        ...state,
        appointments: [],
        appointmentsPricing: [],
        bookPtDetail: null
      }

    default:
      return state
  }
}
